var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PuSkeleton',{attrs:{"loading":_vm.isLoading,"count":1,"width":"100%","height":"240px"}},[_c('line-chart',{attrs:{"chartdata":_vm.chart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }